/// Port of mobile/lib/features/settings/ui/support_section.dart.

import { useTranslation } from 'react-i18next';

import { appEnv } from '@/app/env/appEnv';
import { useSnackbarStore } from '@/app/ui/snackbar/snackbarStore';
import { useAuthStore } from '@/auth/handler/authStore';
import { composeEmail } from '@/support/data/supportRepository';
import { supportEmail } from '@/support/domain/supportContact';
import { useThemeColors } from '@/settings/handler/settingsStore';
import { PixelContainer } from '@/ui/pixel/PixelContainer';

export function SupportSection() {
  const { t } = useTranslation();
  const colors = useThemeColors();
  const user = useAuthStore((s) => s.user);
  const showError = useSnackbarStore((s) => s.error);

  const bodyStyle = {
    fontSize: 18,
    lineHeight: 1.2,
    color: colors.onSurface,
    opacity: 0.78,
  } as const;

  const subheadStyle = {
    fontSize: 20,
    lineHeight: 1,
    color: colors.onSurface,
  } as const;

  const compose = (): void => {
    const lines = ['', '', '—', `App: ${appEnv.version} (${appEnv.environment})`, 'Device: web'];
    if (!user.isAnonymous && user.username) lines.push(`Username: ${user.username}`);
    if (!user.isAnonymous && user.email) lines.push(`Account: ${user.email}`);
    const opened = composeEmail(t('supportMailSubject'), lines.join('\n'));
    if (!opened) showError(t('supportMailFailed'));
  };

  return (
    <div className="flex flex-col">
      <p style={bodyStyle}>{t('supportIntro')}</p>
      <h3 className="mt-4 leading-none" style={subheadStyle}>
        {t('supportIncludeTitle')}
      </h3>
      <p className="mt-2" style={bodyStyle}>
        {t('supportIncludeBody')}
      </p>
      <p className="mt-4 leading-none" style={{ fontSize: 20, color: colors.onSurface }}>
        {supportEmail}
      </p>
      <p className="mt-2" style={bodyStyle}>
        {t('supportReplyHint')}
      </p>
      <div className="mt-[18px]">
        <PixelContainer
          radius={9}
          pixelScale={2}
          padding="14px 0"
          backgroundColor={colors.onSurface}
          borderColor={colors.onSurface}
          onClick={compose}
        >
          <span className="block text-center leading-none" style={{ fontSize: 20, color: colors.surface }}>
            {t('supportCta')}
          </span>
        </PixelContainer>
      </div>
    </div>
  );
}
